export const CONTACT = {
  name: "Rithwik Srivastav",
  title: "Senior Software Engineer | Full Stack & Cloud Architect",
  bio: "Senior Software Engineer with end-to-end expertise spanning full-stack web applications (React, Python Django, Drupal CMS, Node.js), scalable database design (PostgreSQL, MySQL), container orchestration (Docker, Kubernetes), Infrastructure as Code (Terraform), and enterprise CI/CD release engineering across AWS & Azure.",
  location: "Hyderabad, India",
  phone: "+91 8309824929",
  email: "rithwiksrivastav91@gmail.com",
  github: "https://github.com/rithwiksrivastav4",
  linkedin: "https://www.linkedin.com/in/rithwik-srivastav-152548323",
  instagram: "https://www.instagram.com/rithwiksrivastav9/",
  snapchat: "https://www.snapchat.com/add/rithwiksrivas21?share_id=py7Aksugy7I&locale=en-IN",
  x: "https://x.com/rithwiksri534",
  resume: "/Rithwik_software_engineer.pdf",
  alternateResume: "/Rithwik_software_engineer.pdf",
  profileImage: "/myimage.png"
};

export const ROTATING_ROLES = [
  "Software Engineer",
  "Full Stack Developer",
  "Cloud Engineer",
  "Drupal Developer",
  "React Developer",
  "Python Django Developer"
];

export const STATS = [
  { label: "Years Experience", value: 2, suffix: "+" },
  { label: "Projects Completed", value: 10, suffix: "+" },
  { label: "Technologies Mastered", value: 30, suffix: "+" },
  { label: "Certifications", value: 8, suffix: "" },
  { label: "Target System Uptime", value: 99.9, suffix: "%" }
];

export const ACHIEVEMENTS = [
  { label: "Projects Completed", value: 10, suffix: "+" },
  { label: "Technologies Used", value: 30, suffix: "+" },
  { label: "Applications Deployed", value: 15, suffix: "+" },
  { label: "Cloud Platforms", value: 2, suffix: " (AWS & Azure)" },
  { label: "Containers Managed", value: 50, suffix: "+" }
];

export const SERVICES = [
  {
    title: "Software Development",
    desc: "Designing and engineering robust, scalable software systems with clean architecture, OOP principles, and optimized logic.",
    icon: "Code2"
  },
  {
    title: "Web Development",
    desc: "Building responsive, modern, high-performance web applications using modern JavaScript standards and clean UI components.",
    icon: "Globe"
  },
  {
    title: "Drupal Development",
    desc: "Custom Drupal module creation, twig theme development, REST API integration, payment gateways, and multi-language enterprise CMS builds.",
    icon: "Layers"
  },
  {
    title: "React Development",
    desc: "Crafting dynamic, fast, single-page application interfaces with state management, reusable hooks, and Framer Motion micro-interactions.",
    icon: "Atom"
  },
  {
    title: "Python & Django Development",
    desc: "Developing full-stack features, Django REST Framework backends, database ORM integrations, and microservices architecture.",
    icon: "FileCode"
  },
  {
    title: "Cloud Engineering",
    desc: "Provisioning and managing scalable AWS & Azure cloud environments, virtual networks, compute instances, EKS, and IAM policies.",
    icon: "Cloud"
  },
  {
    title: "DevOps & Containerization",
    desc: "Docker containerization, multi-stage image optimization, Kubernetes deployment manifests, ingress controllers, and Helm charts.",
    icon: "Cpu"
  },
  {
    title: "Infrastructure Automation",
    desc: "Infrastructure as Code (IaC) with modular Terraform scripts and Ansible configuration management playbooks.",
    icon: "Wrench"
  },
  {
    title: "API Development & Microservices",
    desc: "Designing RESTful APIs, microservices integration, payment gateway hooks, and third-party web services synchronization.",
    icon: "Server"
  },
  {
    title: "Database Design & Optimization",
    desc: "Relational schema design, query optimization, indexing, backup/restore procedures for MySQL and PostgreSQL databases.",
    icon: "Database"
  },
  {
    title: "Deployment Automation",
    desc: "Automating zero-downtime CI/CD delivery pipelines using Jenkins, GitHub Actions, and GitOps ArgoCD workflows.",
    icon: "GitPullRequest"
  }
];

export const SKILLS_CATEGORIZED = [
  {
    category: "Programming",
    skills: [
      { name: "Python", logo: "/logos/python.svg", desc: "Core language for backend, automation & microservices" },
      { name: "JavaScript", logo: "/logos/javascript.svg", desc: "ES6+ dynamic web logic & full-stack development" },
      { name: "PHP", logo: "/logos/drupal.svg", desc: "Server-side web development & Drupal CMS custom extensions" }
    ]
  },
  {
    category: "Backend",
    skills: [
      { name: "Django", logo: "/logos/django.svg", desc: "Python web framework for scalable REST APIs & backend services" },
      { name: "Node.js", logo: "/logos/nodejs.svg", desc: "Asynchronous JavaScript runtime for API services" },
      { name: "Drupal", logo: "/logos/drupal.svg", desc: "Enterprise CMS architecture, custom modules & themes" }
    ]
  },
  {
    category: "Frontend",
    skills: [
      { name: "React", logo: "/logos/react.svg", desc: "Component-driven SPA frontend interfaces" },
      { name: "HTML5", logo: "/logos/html5.svg", desc: "Semantic web page structure & markup" },
      { name: "CSS3", logo: "/logos/css3.svg", desc: "Modern layouts, flexbox, grid & keyframe animations" },
      { name: "Bootstrap", logo: "/logos/bootstrap.svg", desc: "Responsive UI layout framework" },
      { name: "Tailwind CSS", logo: "/logos/css3.svg", desc: "Utility-first CSS styling framework" }
    ]
  },
  {
    category: "Database",
    skills: [
      { name: "MySQL", logo: "/logos/mysql.svg", desc: "Relational database management & SQL queries" },
      { name: "PostgreSQL", logo: "/logos/postgresql.svg", desc: "Advanced enterprise relational SQL database system" }
    ]
  },
  {
    category: "Cloud",
    skills: [
      { name: "AWS", logo: "/logos/aws.svg", desc: "Amazon Web Services (EKS, EC2, S3, IAM, CloudWatch)" },
      { name: "Azure", logo: "/logos/azure.svg", desc: "Microsoft Azure cloud platform & DevOps services" }
    ]
  },
  {
    category: "DevOps",
    skills: [
      { name: "Docker", logo: "/logos/docker.svg", desc: "Application containerization & multi-stage builds" },
      { name: "Kubernetes", logo: "/logos/kubernetes.svg", desc: "Container orchestration, auto-scaling & cluster management" },
      { name: "Terraform", logo: "/logos/terraform.svg", desc: "Infrastructure as Code (IaC) for AWS & Azure" },
      { name: "Ansible", logo: "/logos/ansible.svg", desc: "Configuration management & server provisioning" },
      { name: "Helm", logo: "/logos/helm.svg", desc: "Kubernetes package manager & deployment templating" },
      { name: "GitHub Actions", logo: "/logos/githubactions.svg", desc: "Native CI/CD workflows & automated testing" },
      { name: "Jenkins", logo: "/logos/jenkins.svg", desc: "Automated CI/CD build & release pipeline server" },
      { name: "ArgoCD", logo: "/logos/argocd.svg", desc: "GitOps continuous delivery synchronization for Kubernetes" },
      { name: "SonarQube", logo: "/logos/sonarqube.svg", desc: "DevSecOps static code security analysis" },
      { name: "Azure DevOps", logo: "/logos/azuredevops.svg", desc: "Enterprise CI/CD pipelines & agile boards" }
    ]
  },
  {
    category: "Monitoring",
    skills: [
      { name: "Prometheus", logo: "/logos/prometheus.svg", desc: "Metrics scraping, time-series data & alerting" },
      { name: "Grafana", logo: "/logos/grafana.svg", desc: "Real-time metrics dashboards & operational visualization" },
      { name: "CloudWatch", logo: "/logos/cloudwatch.svg", desc: "AWS infrastructure telemetry & log monitoring" }
    ]
  },
  {
    category: "Version Control",
    skills: [
      { name: "Git", logo: "/logos/git.svg", desc: "Distributed source code version control system" },
      { name: "GitHub", logo: "/logos/github.svg", desc: "Code hosting, pull requests & DevOps collaboration" },
      { name: "GitLab", logo: "/logos/gitlab.svg", desc: "Version control & integrated DevOps platform" },
      { name: "Bitbucket", logo: "/logos/bitbucket.svg", desc: "Git code management for enterprise software teams" }
    ]
  },
  {
    category: "Tools & Scripting",
    skills: [
      { name: "Bash", logo: "/logos/bash.svg", desc: "Linux shell scripting & command-line automation" },
      { name: "PowerShell", logo: "/logos/powershell.svg", desc: "Cross-platform task automation framework" },
      { name: "Nginx", logo: "/logos/nginx.svg", desc: "High-performance web server & reverse proxy" },
      { name: "YAML", logo: "/logos/yaml.svg", desc: "Kubernetes & CI/CD manifest configuration standard" },
      { name: "VS Code", logo: "/logos/vscode.svg", desc: "Primary IDE workbench & developer extensions" }
    ]
  }
];

export const EXPERIENCE = [
  {
    company: "GISFY Pvt. Ltd.",
    location: "Hyderabad",
    role: "Software Engineer / DevOps Engineer",
    duration: "Nov 2025 – Present",
    status: "Current Role",
    bullets: [
      "Developed and maintained web applications using Drupal CMS, customizing modules and themes to meet complex project requirements.",
      "Managed end-to-end deployment of Drupal applications using Docker, ensuring scalable and consistent environments across dev and prod, reducing setup time by ~50%.",
      "Implemented DevOps practices including containerization, environment setup, and deployment automation.",
      "Worked on React.js projects to build dynamic, component-driven, and responsive user interfaces.",
      "Developed full-stack features using Python (Django), handling both frontend integration and backend logic.",
      "Designed and managed PostgreSQL and MySQL databases, ensuring optimized queries, data integrity, and high performance."
    ],
    tech: ["Software Engineering", "Drupal CMS", "Docker", "React.js", "Python", "Django", "PostgreSQL", "MySQL", "DevOps"]
  },
  {
    company: "Quality Thoughts Pvt. Ltd",
    location: "Hyderabad",
    role: "DevOps Engineer",
    duration: "Aug 2024 – Oct 2025",
    status: "Completed",
    bullets: [
      "Built and managed CI/CD pipelines using Jenkins and GitHub Actions, automating build, test, and deployment processes.",
      "Containerized applications using Docker and Docker Compose, ensuring consistent development and production environments.",
      "Deployed and managed containerized workloads on Kubernetes (Amazon EKS) for scalable and highly available applications.",
      "Provisioned and maintained cloud infrastructure on AWS using Terraform following Infrastructure as Code (IaC) principles.",
      "Automated server provisioning and configuration management using Ansible.",
      "Managed Linux servers, including system administration, package management, user access, and troubleshooting.",
      "Configured and maintained Nginx as a reverse proxy and web server for application deployments.",
      "Worked with Git for version control, branching strategies, merge requests, and release management.",
      "Managed MySQL and PostgreSQL databases, including backup, restoration, migration, and performance optimization.",
      "Monitored applications and infrastructure with Prometheus & Grafana, analyzed logs, and resolved deployment issues."
    ],
    tech: ["Kubernetes", "EKS", "AWS", "Terraform", "Ansible", "Jenkins", "GitHub Actions", "Docker", "Nginx", "Prometheus", "Grafana", "Linux"]
  },
  // {
  //   company: "VCUBE Software Solutions",
  //   location: "Hyderabad",
  //   role: "DevOps Intern",
  //   duration: "Mar 2025 – Apr 2025",
  //   status: "Internship",
  //   bullets: [
  //     "Worked hands-on with Kubernetes, Docker, Jenkins, Terraform, and Ansible.",
  //     "Implemented automated CI/CD pipelines for staging and production deployments.",
  //     "Deployed and monitored containerized microservices across cloud environments."
  //   ],
  //   tech: ["Docker", "Kubernetes", "Jenkins", "Terraform", "Ansible", "CI/CD"]
  // }
];

export const PROJECTS = [
  {
    title: "DRUPAL: SHOC (SADC Regional Government Project)",
    category: "Government Enterprise CMS & Full-Stack Platform",
    featured: true,
    desc: "Developed a custom Drupal theme by implementing Figma-based UI/UX designs, delivering a responsive and pixel-perfect interface across 60+ pages within a 3-month timeline. Built and integrated custom Drupal modules with REST API integrations, multi-language support, and payment gateway integration.",
    tags: ["Drupal CMS", "Docker", "PHP", "REST API", "Full Stack", "Figma UI/UX"],
    status: "Production Live",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Pixel-perfect 60+ page custom theme delivered in 3 months",
      "Built custom REST API integrations & multi-language localization",
      "Dockerized container deployment cutting environment setup time by ~50%"
    ]
  },
  {
    title: "Multi-cloud Infrastructure (Terraform)",
    category: "Infrastructure as Code & Cloud Automation",
    featured: false,
    desc: "Automated infrastructure provisioning across AWS and Azure using modularized Infrastructure as Code (IaC) with Terraform for scalable, repeatable, and audited cloud environments.",
    tags: ["Terraform", "AWS", "Azure", "IaC", "Cloud Infrastructure"],
    status: "Infrastructure",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Multi-cloud AWS & Azure automated infrastructure provisioning",
      "Modular IaC templates for zero drift deployment"
    ]
  },
  {
    title: "Kubernetes Cluster Deployment",
    category: "Cloud Orchestration & High Availability",
    featured: false,
    desc: "Provisioned and bootstrapped a production-ready Kubernetes cluster using IaC (Terraform) and configuration management (Ansible). Configured high availability, auto-scaling, and seamless service discovery.",
    tags: ["Kubernetes", "Terraform", "Ansible", "Amazon EKS", "AWS"],
    status: "Cluster Production",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Production-grade Kubernetes cluster setup via Terraform & Ansible",
      "Configured auto-scaling, ingress routing, and high availability"
    ]
  },
  {
    title: "Spring Boot Microservice Deployment",
    category: "Containerization & K8s Orchestration",
    featured: false,
    desc: "Containerized a Spring Boot Java microservice using multi-stage Dockerfiles and deployed it on Kubernetes. Ensured zero-downtime rolling updates, auto-scaling, and service discovery.",
    tags: ["Docker", "Kubernetes", "Spring Boot", "CI/CD", "Java"],
    status: "Deployed",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Optimized multi-stage Docker builds for minimal container sizes",
      "Deployed on K8s with zero-downtime rolling update strategy"
    ]
  },
  {
    title: "Python Microservices Application",
    category: "Full Stack Microservices Architecture",
    featured: false,
    desc: "Built and deployed a set of 5 containerized Python microservices using Docker and Terraform on a Kubernetes cluster. Configured Nginx load balancers and persistent volumes for reliable data storage.",
    tags: ["Python", "Django", "Microservices", "Docker", "Kubernetes", "Terraform"],
    status: "Microservices",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "5 containerized Python microservices working in sync",
      "Persistent volume mounts & Nginx reverse proxy load balancing"
    ]
  },
  {
    title: "Ansible Automation (Java & React)",
    category: "Application Release Automation",
    featured: false,
    desc: "Automated Java backend and React frontend application deployments using customized Ansible playbooks for zero-error continuous delivery and server provisioning.",
    tags: ["Ansible", "Automation", "React.js", "Java", "Linux"],
    status: "Automated",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Custom Ansible playbooks for single-click deployment",
      "Zero-downtime web server configuration management"
    ]
  },
  {
    title: "GitOps CI/CD Pipeline",
    category: "DevSecOps & Release Engineering",
    featured: false,
    desc: "Designed GitHub Actions & ArgoCD pipelines for automated container image builds, SonarQube static code vulnerability scanning, and git-triggered Kubernetes cluster synchronization.",
    tags: ["GitOps", "ArgoCD", "GitHub Actions", "SonarQube", "Docker"],
    status: "GitOps Pipeline",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Automated continuous delivery using ArgoCD & GitOps",
      "Integrated static security analysis with SonarQube"
    ]
  },
  {
    title: "Monitoring with Prometheus & Grafana",
    category: "Observability & Infrastructure Telemetry",
    featured: false,
    desc: "Established full-stack telemetry and real-time operational metrics across cloud infrastructure and applications using Prometheus metrics collection and Grafana visualization dashboards.",
    tags: ["Prometheus", "Grafana", "CloudWatch", "Monitoring", "Alerting"],
    status: "Live Telemetry",
    github: "https://github.com/rithwiksrivastav4",
    link: "https://github.com/rithwiksrivastav4",
    highlights: [
      "Custom Grafana dashboards for cluster & host metrics",
      "Configured Prometheus Alertmanager for proactive incident response"
    ]
  }
];

export const EDUCATION = [
  {
    school: "Trinity College of Engineering and Technology",
    degree: "Bachelor of Technology in Computer Science Engineering",
    year: "2020 – 2024",
    score: "70% (7.31 CGPA)",
    details: "Specialized in Computer Science, Software Engineering, Data Structures, Network Administration, and Cloud Computing."
  },
  {
    school: "Sri Venkateshwera Junior College",
    degree: "Intermediate (MPC — Maths, Physics, Chemistry)",
    year: "2018 – 2020",
    score: "91% (915/1000)",
    details: "Focused on advanced Mathematics, Physical Sciences, and Logical Reasoning."
  },
  {
    school: "Brilliant Model High School",
    degree: "Secondary School Certificate (SSC / 10th)",
    year: "2018",
    score: "90% (9.0 GPA)",
    details: "Achieved top academic performance with distinction in Mathematics and Science."
  }
];

export const CERTIFICATES = [
  { name: "AWS Scaler Certificate", src: "/certs/aws.png", category: "Cloud & AWS" },
  { name: "MySQL Database Certification", src: "/certs/mysql.png", category: "Database" },
  { name: "Problem Solving (Basic) — HackerRank", src: "/certs/problem_solving_basic certificate.jpg", category: "Algorithms" },
  { name: "Python Assignment Certification", src: "/certs/PYTHON ASSIGNMENT.png", category: "Python" },
  { name: "Python (Basic) Certificate", src: "/certs/python_basic certificate.jpg", category: "Python" },
  { name: "Python Scaler Certification", src: "/certs/python.png", category: "Python" },
  { name: "SQL (Basic) — HackerRank", src: "/certs/sql_basic certificate.jpg", category: "SQL & Databases" },
  { name: "SQL (Intermediate) — HackerRank", src: "/certs/sql_intermediate certificate.jpg", category: "SQL & Databases" }
];
